// extracted by mini-css-extract-plugin
module.exports = {"byline":"ResultsCharts-byline-1GxtOrD_5Y color-midtone-1b38Xj_mpm type-leadingTight-3_Dygk8CBc"};